import script from "./AlertApp.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertApp.vue?vue&type=script&setup=true&lang=js"

import "./AlertApp.vue?vue&type=style&index=0&id=8a339d8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a339d8c"]])

export default __exports__